<script setup lang="ts">
  import { useVModel } from '@vueuse/core'
  import type { HTMLAttributes, TextareaHTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  const props = defineProps<{
    defaultValue?: string | number
    modelValue?: string | number | null
    class?: HTMLAttributes['class']
    rows?: TextareaHTMLAttributes['rows']
  }>()

  const emits = defineEmits<{
    (e: 'update:modelValue', payload: string | number): void
  }>()

  const modelValue = useVModel(props, 'modelValue', emits, {
    passive: true,
    defaultValue: props.defaultValue
  })
</script>

<template>
  <textarea
    v-model="modelValue"
    data-slot="textarea"
    :rows="rows"
    :class="
      cn(
        'border-input dark:bg-input/30 selection:bg-primary selection:text-primary-foreground field-sizing-content flex min-h-14 w-full rounded-md border bg-transparent px-3 py-2 text-base outline-none transition-[color,box-shadow] placeholder:text-neutral-400 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 dark:placeholder:text-neutral-500 md:text-sm',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'read-only:bg-muted/50 read-only:focus-visible:border-input read-only:focus-visible:ring-0',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        props.class
      )
    "
  />
</template>
